<template>
<v-card @mouseover="hover=true" @mouseleave="hover=false" height="100%">
    <v-card-title primary-title>
        <div class="hotel-card-title pa-2">
            {{ $t('hotel.card.policy.title') }}
        </div>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <div v-on="on" class="procent" @click="status_dialog = true">
                    <span :class="color + '--text'">
                        {{ procent_status }}%
                    </span>
                    <v-icon size="19" :color="color">info</v-icon>
                </div>
            </template>
            <div class="">
                <div class=" important white--text">
                    Rata completare <span class="text-lowercase"> {{ $t('hotel.card.policy.title') }} </span>
                </div>
                <div class="" v-if="!(item.static.policy.checkin.from&&item.static.policy.checkin.to&&item.static.policy.checkout.from&&item.static.policy.checkout.to)">
                    Orele de chek-in si check-out sunt necesare pentru a informa clientii
                </div>
                <div class="" v-if="!item.static.defaults.weekend||!item.static.defaults.weekend.length">
                    Zilele de weekend sunt zilele ce mai aglomarate
                </div>
                <div class="" v-if="!item.language">
                    Limba materna este necesara pentru a informa clientii
                </div>
                <div class="" v-if="!item.static.policy.spoken_languages||!item.static.policy.spoken_languages.length">
                    O limba internationala va poate aduce mai multe rezervari
                </div>
                <div class="" v-if="!item.static.defaults.currency">
                    Moneda este necesara pentru a informa clientii in legatura cu plata rezervarii
                </div>
                <div class="" v-if="!item.static.financial.currencies||!item.static.financial.currencies.length">
                    Plata intr-o moneda internationala va poate aduce mai multe rezervari
                </div>
                <div class="" v-if="!item.static.financial.accepted_cards||!item.static.financial.accepted_cards.length">
                    Plata cu cardul va poate aduce mai multe rezervari
                </div>
                <div class="" v-if="!single_stay">
                    Regimul single stay va poate aduce mai multe rezervari
                </div>
                <div class="" v-if="!extra_bed">
                    Paturi suplimentare in camera va poate aduce mai multe rezervari
                </div>
                <div class="" v-if="!(item.terms.ro||item.terms.en)">
                    Termenii sunt pentru informa clientii
                </div>
                <div class="" v-if="procent_status == 100">
                    Felicitari unitatea dvs are informatii complete si sanse mai mari la noi rezervari
                </div>
            </div>
        </v-tooltip>
        <v-icon class="pa-1 icon-edit" color="#5A8DEE" v-show="hover" @click="emitOpenDialog()">edit</v-icon>
    </v-card-title>
    <v-card-text ref="policy-card" id="policy-card">
        <v-row>
            <v-col md="6" cols="12" class="py-0">
                <div class="">
                    <div class="pa-1">
                        {{ $t('hotel.card.policy.accommodation_policies') }}
                    </div>
                    <div class="px-1">
                        <span class="px-1">Check-in:</span>
                        <span>{{item.static.policy.checkin.from}}</span>
                        <v-icon color="#727e8c">arrow_right</v-icon>
                        <span>{{item.static.policy.checkin.to}}</span>
                    </div>
                    <div class="px-1">
                        <span class="px-1">Check-out:</span>
                        <span>{{item.static.policy.checkout.from}}</span>
                        <v-icon color="#727e8c">arrow_right</v-icon>
                        <span>{{item.static.policy.checkout.to}}</span>
                    </div>
                    <div class="px-1">
                        <span class="px-1">{{ $t('hotel.card.policy.weekend_days') }}: </span>
                        <template v-for="day in item.static.defaults.weekend">
                            <span class="px-1">{{ $t('week_days_short.' + days.find(function(item) { return item.value == day }).text) }}</span>
                        </template>
                    </div>
                </div>
                <div class="pa-1 mt-1">{{ $t('hotel.card.policy.currencies_and_payments') }}</div>
                <div class="pa-2">
                    <div class="">
                        <span>{{ $t('hotel.card.policy.defalut_currency') }} :</span>
                        <span> {{item.static.defaults.currency}}</span>
                    </div>
                    <div class="">
                        <span>{{ $t('hotel.card.policy.all_currencies') }} :</span>
                        <template v-for="currency in item.static.financial.currencies">
                            <span class="px-1"> {{ currency }} </span>
                        </template>
                    </div>

                    <div class="d-flex align-center" v-if="item.static.financial.accepted_cards && item.static.financial.accepted_cards.length">
                        <div class="">{{ $t('hotel.card.policy.credit_cards') }} :</div>
                        <template v-for="card in item.static.financial.accepted_cards">
                            <v-avatar tile :size="$vuetify.breakpoint.smAndUp?'36px':'24px'" class="mx-1">
                                <img :src="returnCard(card)" alt="Avatar">
                            </v-avatar>
                        </template>
                    </div>
                </div>
            </v-col>
            <v-col md="6" cols="12" class="py-0">
                <div class="py-1">
                    <div class="">
                        {{ $t('hotel.card.policy.children') }}
                    </div>
                    <div class="px-2" v-if="item.static.policy.children.allowed == '0'">
                        {{ $t('hotel.card.policy.children_not_allowed') }}
                    </div>
                    <div class="px-2" v-else>
                        <div class="" v-if="item.static.policy.children.infants.allowed == 0 && item.static.policy.children.small_children.allowed == 0 && item.static.policy.children.big_children.allowed == 0">
                            {{ $t('hotel.card.policy.children_allowed') }}
                        </div>
                        <div class="" v-else>
                            <div class="" v-if="item.static.policy.children.infants.allowed == 1">
                                <span>
                                    {{ $t('hotel.card.policy.infants') }}
                                    <span class="faded">({{ item.static.policy.children.infants.age.from }}-{{ item.static.policy.children.infants.age.to }} {{ $t('hotel.card.policy.years') }})</span>
                                    :
                                </span>
                                <span class="pl-1">{{ item.static.policy.children.infants.price.value }}</span>
                                <span v-if="item.static.policy.children.infants.price.type == 'percent'">{{ $t('hotel.card.policy.percent_adult') }}</span>
                                <span v-else>{{item.static.defaults.currency}}</span>
                            </div>
                            <div class="" v-if="item.static.policy.children.small_children.allowed == 1">
                                <span>
                                    {{ $t('hotel.card.policy.small_children') }}
                                    <span class="faded">({{ item.static.policy.children.small_children.age.from }}-{{ item.static.policy.children.small_children.age.to }} {{ $t('hotel.card.policy.years') }})</span>
                                    :
                                </span>
                                <span class="pl-1">{{ item.static.policy.children.small_children.price.value }}</span>
                                <span v-if="item.static.policy.children.small_children.price.type == 'percent'">{{ $t('hotel.card.policy.percent_adult') }}</span>
                                <span v-else>{{item.static.defaults.currency}}</span>
                            </div>
                            <div class="" v-if="item.static.policy.children.big_children.allowed == 1">
                                <span>
                                    {{ $t('hotel.card.policy.big_children') }}
                                    <span class="faded">({{ item.static.policy.children.big_children.age.from }}-{{ item.static.policy.children.big_children.age.to }} {{ $t('hotel.card.policy.years') }})</span>
                                    :
                                </span>
                                <span class="pl-1">{{ item.static.policy.children.big_children.price.value }}</span>
                                <span v-if="item.static.policy.children.big_children.price.type == 'percent'">{{ $t('hotel.card.policy.percent_adult') }}</span>
                                <span v-else>{{item.static.defaults.currency}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="py-1">
                    <div class="">
                        {{ $t('hotel.card.policy.extra_beds') }}
                    </div>
                    <div class="px-2" v-if="extra_bed">
                        <span>{{ item.static.policy.extra_beds.value }}</span>
                        <span v-if="item.static.policy.extra_beds.type == 'percent'">{{ $t('hotel.card.policy.percent_room') }}</span>
                        <span v-else>{{item.static.defaults.currency}}</span>
                    </div>
                    <div class="px-2" v-else>
                        <span>{{$t('hotel.card.policy.no_extra_beds')}}</span>
                    </div>
                </div>
                <div class="py-1">
                    <div class="">
                        {{ $t('hotel.card.policy.single_stay') }}
                    </div>
                    <div class="px-2" v-if="single_stay">
                        <span>{{ item.static.policy.single_stay.value }}</span>
                        <span v-if="item.static.policy.single_stay.type == 'percent'">{{ $t('hotel.card.policy.percent_room') }}</span>
                        <span v-else>{{item.static.defaults.currency}}</span>
                    </div>
                    <div class="px-2" v-else>
                        <span>{{$t('hotel.card.policy.no_single_stay')}}</span>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-card-text>

    <!--info dialog-->
    <v-dialog v-model="status_dialog" max-width="720">
        <v-card>
            <v-card-title class="hotel-card-title" primary-title>
                Info
            </v-card-title>
            <v-card-text class="info-text">
                <div class="" v-if="!(item.static.policy.checkin.from&&item.static.policy.checkin.to&&item.static.policy.checkout.from&&item.static.policy.checkout.to)">
                    Orele de chek-in si check-out sunt necesare pentru a informa clientii
                </div>
                <div class="" v-if="!item.static.defaults.weekend||!item.static.defaults.weekend.length">
                    Zilele de weekend sunt zilele ce mai aglomarate
                </div>
                <div class="" v-if="!item.language">
                    Limba materna este necesara pentru a informa clientii
                </div>
                <div class="" v-if="!item.static.policy.spoken_languages||!item.static.policy.spoken_languages.length">
                    O limba internationala va poate aduce mai multe rezervari
                </div>
                <div class="" v-if="!item.static.defaults.currency">
                    Moneda este necesara pentru a informa clientii in legatura cu plata rezervarii
                </div>
                <div class="" v-if="!item.static.financial.currencies||!item.static.financial.currencies.length">
                    Plata intr-o moneda internationala va poate aduce mai multe rezervari
                </div>
                <div class="" v-if="!item.static.financial.accepted_cards||!item.static.financial.accepted_cards.length">
                    Plata cu cardul va poate aduce mai multe rezervari
                </div>
                <div class="" v-if="!single_stay">
                    Regimul single stay va poate aduce mai multe rezervari
                </div>
                <div class="" v-if="!extra_bed">
                    Paturi suplimentare in camera va poate aduce mai multe rezervari
                </div>
                <div class="" v-if="!(item.terms.ro||item.terms.en)">
                    Termenii sunt pentru informa clientii
                </div>
                <div class="" v-if="procent_status == 100">
                    Felicitari unitatea dvs are informatii complete si sanse mai mari la noi rezervari
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="status_dialog=false">
                    {{ $t('button.exit') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./info dialog -->

</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';
import AmericanExpress from '@/assets/cards/american-express.svg';
import CarteBleue from '@/assets/cards/carte-bleue.svg';
import DinersClub from '@/assets/cards/diners-club.svg';
import Discover from '@/assets/cards/discover.svg';
import JCB from '@/assets/cards/jcb.svg';
import Maestro from '@/assets/cards/maestro.svg';
import Mastercard from '@/assets/cards/master-card.svg';
import Visa from '@/assets/cards/visa.svg';
import UnionPay from '@/assets/cards/unionpay.svg';

export default {
    props: {
        item: Object,
        config: Object,
        active: Object
    },
    name: `hotel-policy`,
    components: {},

    data() {
        return {
            status_dialog: false,
            color: 'grey',
            //cards
            'american-express': AmericanExpress,
            'carte-bleue': CarteBleue,
            'diners-club': DinersClub,
            discover: Discover,
            jcb: JCB,
            maestro: Maestro,
            mastercard: Mastercard,
            visa: Visa,
            unionpay: UnionPay,
            hover: false,
            days: [
                {
                    text: "monday",
                    value: "1",
                    selected: false
                }, {
                    text: "tuesday",
                    value: "2",
                    selected: false
                }, {
                    text: "wednesday",
                    value: "3",
                    selected: false
                }, {
                    text: "thursday",
                    value: '4',
                    selected: false
                }, {
                    text: "friday",
                    value: "5",
                    selected: true
                }, {
                    text: "saturday",
                    value: "6",
                    selected: true
                }, {
                    text: "sunday",
                    value: "0",
                    selected: true
                }
            ],
        };
    },

    created() {},

    computed: {
        single_stay: {
            get: function () {
                return !!this.item.static.policy.single_stay.value || !!this.item.static.policy.single_stay.type
            },
            set: function () {}
        },
        extra_bed: {
            get: function () {
                return !!this.item.static.policy.extra_beds.value || !!this.item.static.policy.extra_beds.type
            },
            set: function (val) {}
        },
        procent_status() {
            let procent = 0;
            if(this.item.static.policy.checkin.from) {
                procent += 10
            }
            if(this.item.static.policy.checkin.to) {
                procent += 5
            }
            if(this.item.static.policy.checkout.from) {
                procent += 10
            }
            if(this.item.static.policy.checkout.to) {
                procent += 5
            }
            if(this.item.static.defaults.weekend) {
                procent += 5
            }
            if(this.item.language) {
                procent += 10
            }
            if(this.item.static.policy.spoken_languages) {
                procent += 5
            }
            if(this.item.static.defaults.currency) {
                procent += 15
            }
            if(this.item.static.financial.currencies && this.item.static.financial.currencies.length) {
                procent += 5
            }
            if(this.item.static.financial.accepted_cards && this.item.static.financial.accepted_cards.length) {
                procent += 10
            }
            if(this.item.static.policy.children.allowed == 1) {
                procent += 5
            }
            if(!!this.item.static.policy.extra_beds.value || !!this.item.static.policy.extra_beds.type) {
                procent += 5
            }
            if(!!this.item.static.policy.single_stay.value || !!this.item.static.policy.single_stay.type) {
                procent += 5
            }
            if(this.item.terms.ro) {
                procent += 3
            }
            if(this.item.terms.en) {
                procent += 2
            }
            this.setColor(procent);

            return procent;
        }
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        returnCard(value) {
            return this[value]
        },

        setColor(procent) {
            if(procent < 51) {
                this.color = 'red'
            }
            if(50 < procent && procent < 81) {
                this.color = 'orange'
            }
            if(procent > 80) {
                this.color = 'green'
            }
        },

        emitOpenDialog() {
            this.$emit('openDialog');
        }
    },

};
</script>

<style lang="stylus">
.drop-down
    max-height: 0px
    transition: max-height 0.25s ease-out
    overflow: hidden
    &.open
        max-height: 300px
        transition: max-height 0.25s ease-in
</style>
